import { DeserializedObject } from '@/src/lib/http/jsonapi/deserializer';
import { DeserializedCompanyUser } from '@/src/lib/company-user/types';
import { DeserializedCart } from '@/src/lib/cart/glue/types/deserialized';
import { PRICING_REFERENCE_OPTIONS } from '@/src/lib/company-business-units/types';

type PricingReferenceKeyValue =
  | {
      key: PRICING_REFERENCE_OPTIONS;
      value: string;
    }
  | { key: undefined; value: undefined };

export function getDefaultCompanyUser(
  companyUsers: Array<DeserializedObject<DeserializedCompanyUser>>,
): DeserializedObject<DeserializedCompanyUser> {
  return companyUsers.find((companyUser) => companyUser.isDefault) || companyUsers[0];
}

export function getDefaultCompanyBusinessUnit(companyUsers: Array<DeserializedObject<DeserializedCompanyUser>>) {
  const defaultCompanyUser = getDefaultCompanyUser(companyUsers);

  if (!defaultCompanyUser || !defaultCompanyUser.companyBusinessUnits.length) {
    return undefined;
  }

  return defaultCompanyUser.companyBusinessUnits[0];
}

export function getSelectedPricingReferenceKeyValue(cart?: DeserializedCart): PricingReferenceKeyValue {
  let selectedPricingReference: PricingReferenceKeyValue = {
    key: undefined,
    value: undefined,
  };

  if (!cart) {
    return selectedPricingReference;
  }

  if (cart.priceReferenceQuoteId) {
    selectedPricingReference = { key: PRICING_REFERENCE_OPTIONS.QUOTE, value: cart.priceReferenceQuoteId };
  }

  if (cart.priceReferenceProjectNumber) {
    selectedPricingReference = { key: PRICING_REFERENCE_OPTIONS.PROJECT, value: cart.priceReferenceProjectNumber };
  }

  return selectedPricingReference;
}

export function getSelectedPricingReferenceOptionValue(cart?: DeserializedCart): string | undefined {
  const selectedPricingReference = getSelectedPricingReferenceKeyValue(cart);
  if (!selectedPricingReference.key || !selectedPricingReference.value) {
    return undefined;
  }

  return `${selectedPricingReference.key}-${selectedPricingReference.value}`;
}

export function getSelectedPricingReference(cart?: DeserializedCart): string | undefined {
  const { value: selectedPricingReference } = getSelectedPricingReferenceKeyValue(cart);

  return selectedPricingReference;
}
